export const doRequest = async (url, settings = null) => {
    return await (fetch(url, settings));
}
